"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSearchFilterDateContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
// import * as Colors from "../colors";
exports.ManagerSearchFilterDateContainer = styled_components_1.default.div `
  input,
  label {
    display: inline;
    width: initial;
  }

  input {
    vertical-align: middle;
  }
`;
//# sourceMappingURL=search-filter-date-container.js.map